import axios from "axios";

// Load API URL only from .env
const BASE_URL = process.env.REACT_APP_API_URL;

if (!BASE_URL) {
  console.error("❌ REACT_APP_API_URL missing in .env file");
}

console.log("📡 Using API URL:", BASE_URL);

const api = axios.create({
  baseURL: BASE_URL,
  headers: { "Content-Type": "application/json" }
});

// Attach JWT
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const blockUser = async (id) => {
  try {
    const { data } = await api.post(`/users/${id}/block`);
    return data;
  } catch (err) {
    console.error("Block user error:", err);
    return { error: true, message: "Failed to block user" };
  }
};

export const unblockUser = async (id) => {
  try {
    const { data } = await api.post(`/users/${id}/unblock`);
    return data;
  } catch (err) {
    console.error("Unblock user error:", err);
    return { error: true, message: "Failed to unblock user" };
  }
};

export default api;
